import i18n from "./i18n";
import ReactDOM from "react-dom/client";
import "./styles/tailwind.css";
import * as serviceWorker from "./serviceWorker";
import React from "react";
import Router from "./router";
import TagManager from "react-gtm-module";
import * as Sentry from "@sentry/react";
import { UserProvider } from "./context/useContext";
import setupGlobalErrorHandler from "./utils/globalErrorHandler";
import { setupAuthInterceptor } from "./utils/setupAuthInterceptor";
import { AuthProvider } from "./context/useAuthContext";
import { BrowserRouter } from "react-router-dom";
import SentryErrorBoundary from "./components/SentryErrorBoundary";
import axios from "axios";
import { DownloadBannerProvider } from "./context/DownloadBannerContext";
import DownloadBanner from "./components/common/DownloadBanner";
import { TourProvider } from "./context/TourContext";
import { ToastProvider } from "./components/common/Banner/ToastContainer";
export const appVersion = process.env.REACT_APP_VERSION ?? "dev";

if (process.env.REACT_APP_ENV === "production") {
  Sentry.init({
    dsn: "https://7cd028f5db756bdc09f85107c65dcba6@o4507329664057344.ingest.de.sentry.io/4507329670414416",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: `v${appVersion}`,
    beforeSend(event) {
      if (
        event.message?.includes("Tawk") ||
        event.exception?.values?.some((e) => e.type?.includes("Tawk"))
      ) {
        return null; // skip this event
      }
      return event;
    },
  });
  const gtmTrackingId = "GTM-N8PWSQ2Q";

  if (gtmTrackingId) {
    const tagManagerArgs = { gtmId: gtmTrackingId };
    TagManager.initialize(tagManagerArgs);
  } else {
    console.log("Google Tag Manager tracking ID not found");
  }
}

i18n;
setupAuthInterceptor(axios);
setupGlobalErrorHandler();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <SentryErrorBoundary>
        <AuthProvider>
          <DownloadBannerProvider delay={5000}>
            <TourProvider>
              <ToastProvider>
                <Router />
              </ToastProvider>
            </TourProvider>
            <DownloadBanner />
          </DownloadBannerProvider>
        </AuthProvider>
      </SentryErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);

serviceWorker.unregister();
